// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"25923c7f","225":"aefc796f","263":"ba82589b","343":"dc51ad20","418":"09632bb1","578":"ceb47c88","617":"a0c828b3","713":"02b79d85","877":"2c4c28b7"}[chunkId] + ".chunk.css";
};